import { render, staticRenderFns } from "./boas-vindas.vue?vue&type=template&id=3bb96838&"
import script from "./boas-vindas.vue?vue&type=script&lang=js&"
export * from "./boas-vindas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports